import script from "./FeelingDoughnutChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeelingDoughnutChart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__